// src/pages/help/DayShiftSportsMMAHelp.js
import React from "react";
import { Link } from "react-router-dom";

const DayShiftSportsMMAHelp = () => {
  return (
    <div className="bg-white rounded-lg shadow-md p-6">
      <div className="mb-6">
        <Link to="/help" className="text-deep-red hover:text-bright-red">
          &larr; Back to Help Center
        </Link>
      </div>
      <h1 className="text-3xl font-bold text-dark-grey mb-6">About DayShift Sports MMA</h1>
      <div className="space-y-6">
        <section>
          <h2 className="text-2xl font-semibold text-dark-grey mb-4">What is DayShift Sports MMA?</h2>
          <p className="text-medium-grey">
            DayShift Sports MMA is a fantasy sports platform dedicated to mixed martial arts enthusiasts. 
            We offer a unique fantasy MMA experience where you can compete against friends, family, and other fans 
            by predicting fighter performance in real UFC events.
          </p>
        </section>
        
        <section>
          <h2 className="text-2xl font-semibold text-dark-grey mb-4">How Does it Work?</h2>
          <ol className="list-decimal pl-5 text-medium-grey space-y-2">
            <li>Create or join a league with friends or other MMA fans</li>
            <li>For each UFC event, select fighters you believe will perform well</li>
            <li>Earn points based on your fighters' actual performance in the octagon</li>
            <li>Compete for the top spot in your league's leaderboard</li>
            <li>Track your global ranking against all DayShift Sports users</li>
          </ol>
        </section>
        
        <section>
          <h2 className="text-2xl font-semibold text-dark-grey mb-4">Why Choose DayShift Sports?</h2>
          <ul className="list-disc pl-5 text-medium-grey space-y-2">
            <li><span className="font-medium">MMA Focus:</span> Unlike generic fantasy sports platforms, we specialize in MMA</li>
            <li><span className="font-medium">User-Friendly:</span> Easy-to-use interface designed specifically for MMA fans</li>
            <li><span className="font-medium">Comprehensive Stats:</span> Access detailed fighter statistics and performance metrics</li>
            <li><span className="font-medium">Community:</span> Connect with a passionate community of MMA enthusiasts</li>
            <li><span className="font-medium">Free to Play:</span> Enjoy the full fantasy MMA experience at no cost</li>
          </ul>
        </section>
        
        <section>
          <h2 className="text-2xl font-semibold text-dark-grey mb-4">Getting Started</h2>
          <p className="text-medium-grey">
            To get started with DayShift Sports MMA:
          </p>
          <ol className="list-decimal pl-5 text-medium-grey space-y-2">
            <li>Create an account or sign in</li>
            <li>Join an existing league or create your own</li>
            <li>Familiarize yourself with the scoring system</li>
            <li>Submit your first lineup for an upcoming UFC event</li>
            <li>Invite friends to join and compete against you</li>
          </ol>
        </section>
      </div>
    </div>
  );
};

export default DayShiftSportsMMAHelp;
